import Client from "./Client";
// import RequestList from "./RequestList";

const UsersService = {
    url: 'admin/users',
    getDefault(){
        return {
            id : undefined,
            role_id : undefined,
            reseller_id : undefined,
            manager_reseller_id: undefined,
            full_name : undefined,
            mobile : undefined,
            mobile_verified_at : undefined,
            email : undefined,
            email_verified_at : undefined,
            telegram : undefined,
            telegram_verified_at : undefined,
            disabled_at : undefined,
            created_at : undefined,
            updated_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async compactList(requestList) {
        return await Client.get(`${this.url}/compact`, requestList.json());
    },

    /**
     * @params int userId
     * @return Request Promise
     **/
    async getById(userId) {
        return await Client.get(`${this.url}/${userId}`);
    },
    /**
     * @params user
     * @return Request Promise
     **/
    async create(user) {
        return await Client.post(`${this.url}`, user);
    },

    /**
     * @params user
     * @return Request Promise
     **/
    async update(user) {
        return await Client.post(`${this.url}/${user.id}`, user);
    },

    /**
     * @params time_dimension
     * @params [] filters
     * @return Request Promise
     **/
    async getOverviewReport(time_dimension, filters) {
        return await Client.get(`${this.url}/reports/overview`, {
            time_dimension,
            filters
        });
    }
}

export default UsersService